export const setTourInfo = tourInfo => {
	return { type: 'SET_TOUR_INFO', tourInfo };
};